// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2M0Lf","productName":"Table_productName__2qBAt"};